import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { useAnalytics } from '@/services/analytics';
import { useMountEffect } from '@/hooks/state/use-mount-effect';
import { AssistantFooter } from './assistant-footer';
import { AgentFab } from './agent-fab';

/**
 * Flag switch for the agent entry point: the floating launcher (with the
 * multi-conversation menu) or today's "Ask agent" footer bar.
 */
export function AgentLauncher() {
  const isFloatingLauncherEnabled = useFeatureFlag(AccountFeatureFlag.AgentFloatingLauncher);
  const { track } = useAnalytics();

  // Exposure tracking for the agent_floating_launcher rollout: which arm this
  // load was served, whether or not the user ever opens the agent.
  useMountEffect(() => {
    void track('aiAssistant', 'launcherDisplayed', {
      Variant: isFloatingLauncherEnabled ? 'fab' : 'footer',
    });
  });

  return isFloatingLauncherEnabled ? <AgentFab /> : <AssistantFooter />;
}
